import { Currency } from '../objects/currency';

export default (list: Currency[], page: number, limit: number, search: string) => {
    let displayed_list: Currency[] = [];
    let count = 0;
    for (let i = 0; i < list.length; i++) {
        if (search === '' || (list[i].name ?? list[i].international_name).match(new RegExp(search, 'i'))) {
            if (count >= page * limit && count < (page + 1) * limit) {
                displayed_list.push(list[i]);
            }
            count++;
        }
    }
    return { count, displayed_list };
};